import React, { useEffect, useReducer } from "react";
import IconLink from "components/IconLink";
import useI18n from "i18n/useI18n";
import usePermissions from "state/permissions";
import Form from "../components/Form";
import styled from "styled-components";
import Reducer, { initialState } from './Reducer'
import { useParams } from 'react-router-dom';
import useSalesAdjustment from "state/salesAdjustment";
import { isFutureDate, yesterdayString } from "utils/date";
import FormScrollableContainer from "pages/Group/containers/FormScrollableContainer";
import { useRouter } from "providers/router";
import { toast, ToastContainer } from 'react-toastify';

const CONFIG = {
  position: 'bottom-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const Create = ({ location }) => {

  const { translate } = useI18n();
  const [data, dispatcher] = useReducer(Reducer, initialState);
  const [, saleDispatcher] = useSalesAdjustment();
  const [permissions] = usePermissions();
  const { groupId } = useParams();
  const { route, canGoBack } = useRouter();

  useEffect(() => {
    const eventDate = yesterdayString();
    const payload = {
      sale: { groupId, eventDate },
      movements: [{
        paymentMethod: null,
        paymentMethodName: null,
        food: null,
        drink: null,
        iva: null,
      }]
    }

    dispatcher({ type: "init", payload })
  }, []);

  const onSubmit = (e) => {
      e.preventDefault();

      const eventDate = data.sale.eventDate;
      const movements = data.movements;

      console.log("Event date", eventDate);
      console.log("Movements", movements);

      if (eventDate !== null && isFutureDate(new Date(`${eventDate}T23:59:59`))) {
          let foodTotal = 0;
          let drinkTotal = 0;
          let ivaTotal = 0;
          for (const movement of movements) {
              foodTotal += +movement.food;
              drinkTotal += +movement.drink;
              ivaTotal += +movement.iva;
          }

          if (foodTotal + drinkTotal + ivaTotal < 0) {
              console.error(
                  "Event date cannot be in the future if any movement has a negative value",
              );
              toast.error(
                  "Event date cannot be in the future if any movement has a negative value",
                  {
                      toastId: "futureDateError",
                      onClose: () => {},
                      ...CONFIG,
                  },
              );
              return;
          }
      }
      
      saleDispatcher.createStart(data);
  };

  return (
    <FormScrollableContainer>
      <HeaderContainer>
        <IconLink to={canGoBack() ? route.from : `/${groupId}/adjustments`}>
          {translate("Back to Sales Adjustment")}
        </IconLink>
      </HeaderContainer>
      <div style={{ height: "10px" }}></div>

      <Form
        data={data}
        dispatcher={dispatcher}
        onSubmit={onSubmit}
        title={translate("New Adjustment")}
        loading={permissions.fetching.state}
        buttonText={translate("Save Adjustment")}
      />
    </FormScrollableContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Create;
